import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/authContext";
import { Link } from "react-router-dom";
import Adminsidebar from "../adminsidebar";

export default function AdminHeader() {
  const { logout, userData } = useAuth();
  const [dropdown, setDropdown] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef();
  const [logoutModel, setLogoutModel] = useState(false);
  const [sidebar, setSidebar] = useState(false);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (dropdown && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [dropdown]);

  const handleLogout = async () => {
    await logout();
    window.location.reload();
    localStorage.removeItem("authToken");
    // localStorage.removeItem("usersData");
    navigate("/");
    setLogoutModel(false)
  };

  return (
    <>
      <div className="py-3 sticky top-0 z-40 px-5 bg-white border-solid border-b mobile:gap-0 border-borderColor1 flex items-center justify-end tab:justify-between gap-8">
        <Link to="/dashboard" className="hidden tab:block">
          <img src={"/assets/alladdin_logo.svg"} alt="alladdin_logo" />
        </Link>
        <div className="cursor-pointer">
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clip-path="url(#clip0_905_2650)">
                        <path d="M10.0001 6.36481C9.28099 6.36481 8.57804 6.57805 7.98013 6.97756C7.38222 7.37707 6.91621 7.94491 6.64102 8.60927C6.36583 9.27363 6.29383 10.0047 6.43412 10.71C6.57441 11.4152 6.92069 12.0631 7.42917 12.5716C7.93765 13.08 8.58549 13.4263 9.29078 13.5666C9.99606 13.7069 10.7271 13.6349 11.3915 13.3597C12.0558 13.0845 12.6237 12.6185 13.0232 12.0206C13.4227 11.4227 13.6359 10.7197 13.6359 10.0006C13.6348 9.0367 13.2514 8.11255 12.5698 7.43094C11.8882 6.74932 10.964 6.36591 10.0001 6.36481ZM10.0001 11.1365C9.77545 11.1365 9.55584 11.0699 9.36906 10.9451C9.18227 10.8202 9.03669 10.6429 8.95072 10.4353C8.86475 10.2278 8.84226 9.99938 8.88608 9.77905C8.92991 9.55872 9.03809 9.35633 9.19694 9.19749C9.35579 9.03864 9.55817 8.93046 9.7785 8.88663C9.99883 8.84281 10.2272 8.8653 10.4348 8.95127C10.6423 9.03724 10.8197 9.18282 10.9445 9.36961C11.0693 9.55639 11.1359 9.77599 11.1359 10.0006C11.1357 10.3018 11.016 10.5906 10.803 10.8036C10.59 11.0165 10.3013 11.1363 10.0001 11.1365Z" fill="#777777" />
                        <path d="M18.333 10C18.3318 8.72308 18.0348 7.4638 17.4655 6.32083L17.8939 6.02333C18.1658 5.83379 18.3513 5.544 18.4096 5.2177C18.4679 4.8914 18.3942 4.5553 18.2047 4.28333C18.0151 4.01141 17.7253 3.82591 17.399 3.76761C17.0727 3.70932 16.7367 3.78302 16.4647 3.9725L16.0355 4.27083C14.7631 2.92786 13.0788 2.04803 11.2497 1.77083V1.25C11.2497 0.918479 11.118 0.600537 10.8836 0.366116C10.6491 0.131696 10.3312 0 9.99968 0C9.66816 0 9.35022 0.131696 9.1158 0.366116C8.88138 0.600537 8.74968 0.918479 8.74968 1.25V1.77083C6.92054 2.04803 5.23626 2.92786 3.96385 4.27083L3.53468 3.9725C3.26271 3.78302 2.92662 3.70932 2.60032 3.76761C2.27402 3.82591 1.98423 4.01141 1.79468 4.28333C1.60521 4.5553 1.53151 4.8914 1.5898 5.2177C1.64809 5.544 1.83359 5.83379 2.10552 6.02333L2.53385 6.32083C1.96335 7.46338 1.66637 8.72294 1.66637 10C1.66637 11.2771 1.96335 12.5366 2.53385 13.6792L2.10552 13.9767C1.83359 14.1662 1.64809 14.456 1.5898 14.7823C1.53151 15.1086 1.60521 15.4447 1.79468 15.7167C1.98423 15.9886 2.27402 16.1741 2.60032 16.2324C2.92662 16.2907 3.26271 16.217 3.53468 16.0275L3.96385 15.7292C5.23626 17.0721 6.92054 17.952 8.74968 18.2292V18.75C8.74968 19.0815 8.88138 19.3995 9.1158 19.6339C9.35022 19.8683 9.66816 20 9.99968 20C10.3312 20 10.6491 19.8683 10.8836 19.6339C11.118 19.3995 11.2497 19.0815 11.2497 18.75V18.2292C13.0788 17.952 14.7631 17.0721 16.0355 15.7292L16.4647 16.0275C16.7367 16.217 17.0727 16.2907 17.399 16.2324C17.7253 16.1741 18.0151 15.9886 18.2047 15.7167C18.3942 15.4447 18.4679 15.1086 18.4096 14.7823C18.3513 14.456 18.1658 14.1662 17.8939 13.9767L17.4655 13.6792C18.0348 12.5362 18.3318 11.2769 18.333 10ZM9.99968 15.8333C8.84596 15.8333 7.71814 15.4912 6.75886 14.8502C5.79957 14.2093 5.0519 13.2982 4.61039 12.2323C4.16887 11.1664 4.05336 9.99353 4.27844 8.86197C4.50352 7.73042 5.05909 6.69102 5.87489 5.87521C6.6907 5.0594 7.7301 4.50383 8.86166 4.27875C9.99321 4.05367 11.1661 4.16919 12.232 4.6107C13.2979 5.05221 14.209 5.79989 14.8499 6.75917C15.4909 7.71846 15.833 8.84628 15.833 10C15.831 11.5465 15.2158 13.0291 14.1223 14.1226C13.0287 15.2161 11.5462 15.8313 9.99968 15.8333Z" fill="#777777" />
                    </g>
                    <defs>
                        <clipPath id="clip0_905_2650">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg> */}
        </div>
        <div className="relative">
          <div className="flex items-center gap-4 cursor-pointer " onClick={() => setDropdown(!dropdown)}>
            {userData?.profile ? (
              <img className="w-8 text-xs font-bold h-8 rounded-full object-cover flex justify-center items-center bg-[#d0ee11]" src={userData?.profile} alt="ProfileImage" />
            ) : (
              <p className="w-8 text-xs font-bold h-8 rounded-full object-cover flex justify-center items-center bg-[#d0ee11]">
                {userData?.name
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase())
                  .join("")}
              </p>
            )}
            <div className="flex items-center gap-2">
              <span className="text-xs whitespace-nowrap text-black300 mobile:text-[11px] font-medium">{userData?.name}</span>
              <div className={dropdown ? "animation-trans-up" : "animation-trans"}>
                <i class="fa-solid fa-chevron-down text-xs text-gray700"></i>
              </div>
            </div>
            <div ref={dropdownRef} className={dropdown ? "profile-dropdown show" : "profile-dropdown hide"}>
              <div className="p-2">
                <div
                  onClick={() => {
                    setDropdown(false);
                    navigate(`/setting`);
                  }}
                  className="text-sm flex items-center gap-3 font-medium text-gray700 cursor-pointer p-2 hover:bg-bgHover transition ease-in-out rounded hover:text-black300"
                >
                  <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
                  </svg>
                  Setting
                </div>
                <div
                  onClick={() => {
                    setDropdown(false);
                    navigate(`/profile`);
                  }}
                  className="text-sm flex items-center gap-3 font-medium text-gray700 cursor-pointer p-2 hover:bg-bgHover transition ease-in-out rounded hover:text-black300"
                >
                  <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z" />
                  </svg>
                  Profile
                </div>
              </div>
            </div>
            <div className="hidden cursor-pointer tab:block" onClick={() => setSidebar(!sidebar)}>
              <i class="fa-solid fa-bars"></i>
            </div>
          </div>
        </div>
      </div>
      <div className={sidebar ? "mobile-sidbar-design show" : "mobile-sidbar-design hide"}>
        <Adminsidebar sidebar={sidebar} setSidebar={setSidebar} logoutModel={logoutModel} setLogoutModel={setLogoutModel}/>
      </div>
      {logoutModel && (
          <div className="global-modal" style={{ zIndex: "999999" }}>
            <div className="bg-white rounded-xl w-[580px] p-6  mobile:w-[calc(100%-20px)] mobile:p-4 mobile:overflow-auto">
              {/* <p className="text-lg text-black300 font-medium text-center mb-5">{setIsEditSubscription ? "Edit" : "Add"} Subscription Details</p> */}
              <div className="flex justify-between items-center">
                <p className="text-lg text-black300 font-medium text-center mb-5">Are you sure you want to logout?</p>
              </div>

              <div className="flex justify-end gap-3 pt-3">
                <button
                  className="px-6 py-2 block border-none text-base font-medium text-black300 rounded bg-inputBackground"
                  onClick={() => {
                    setLogoutModel(false);
                  }}
                >
                  Cancel
                </button>
                <button className="px-6 py-2 block border-none text-base font-medium text-black300 rounded bg-primary" onClick={() => handleLogout()}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}
    </>
  );
}
